






























































































import CostHelpType from '@/domain/cost-help-type/entity/cost-help-type.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import CurrencyField from '@/shared/currency-field.component.vue';
import MobileHandler from '@/shared/utils/mobile-handler';

@Component({
  components: {
    ModalWarning,
    LabelSlot,
    CurrencyField,
  },
})
class CostHelpTypeForm extends Vue {
  @Prop({ required: true })
  costHelpType!: CostHelpType;

  @Prop({ type: Boolean, default: false })
  isMobile!: boolean;

  @Prop({ type: Boolean, default: false })
  hasActivateCostHelpTypePermission!: boolean;

  @Prop({ type: Boolean, default: false })
  hasDeleteCostHelpTypePermission!: boolean;

  @Prop({ type: Boolean, default: false })
  hasUpdateCostHelpTypePermission!: boolean;

  @Prop({ type: Boolean, default: false })
  hasCreateNewCostHelpTypePermission!: boolean;

  costHelpTypeToDelete: CostHelpType | null = null;

  showModalWarning: boolean = false;

  isValid: boolean = true;

  rules: Rules = new Rules();

  get modalWarningOptions() {
    return {
      title: 'Importante',
      description: 'Deseja realmente prosseguir? Ao clicar no botão Sim, as alterações serão imediatamente realizadas.',
      showOk: true,
      labelOk: 'Sim',
      showCancel: this.costHelpTypeToDelete ? !this.costHelpTypeToDelete.isLoadingDelete : true,
      labelCancel: 'Cancelar',
      okColor: 'error',
      width: 500,
      loadingOk: this.costHelpTypeToDelete ? this.costHelpTypeToDelete.isLoadingDelete : false,
    }
  }

  handleSaveCostHelpType(costHelpType: CostHelpType): void {
    if (costHelpType.saved) {
      costHelpType.update();
      return;
    }
    costHelpType.create();
  }

  handleDeleteCostHelpType(costHelpType: CostHelpType): void {
    if (!costHelpType.saved) {
      this.$emit('delete-local', costHelpType);
      return;
    }
    this.costHelpTypeToDelete = costHelpType;
    this.showModalWarning = true;
  }

  async handleConfirmDelete(): Promise<void> {
    if (!this.costHelpTypeToDelete) {
      return;
    }
    await this.costHelpTypeToDelete.delete();
    this.costHelpTypeToDelete = null;
    this.showModalWarning = false;
  }

  async handleActivateCostHelpType(costHelpType: CostHelpType): Promise<void> {
    await costHelpType.activate();
  }

  valueMaxRules(): Function[] {
    return [
      () => {
        if (this.costHelpType && this.costHelpType.valueMin > this.costHelpType.valueMax) {
          return 'O valor máximo deve ser maior ou igual ao valor mínimo.';
        }
        return true;
      },
    ];
  }

  valueMinRules(): Function[] {
    return [
      () => {
        if (this.costHelpType && this.costHelpType.valueMin > this.costHelpType.valueMax) {
          return 'O valor mínimo deve ser menor ou igual ao valor máximo.';
        }
        return true;
      },
      () => {
        if (this.costHelpType && this.costHelpType.valueMin <= 0) {
          return 'O valor mínimo deve ser maior que zero.';
        }
        return true;
      },
    ];
  }

  get showDeleteButton(): boolean {
    return this.costHelpType.active && this.hasDeleteCostHelpTypePermission;
  }

  get showSaveButton(): boolean {
    if (!this.costHelpType.active) {
      return false;
    }
    if (this.costHelpType.saved) {
      return this.hasUpdateCostHelpTypePermission;
    }
    return this.hasCreateNewCostHelpTypePermission;
  }

  get showActivateButton(): boolean {
    return !this.costHelpType.active && this.hasActivateCostHelpTypePermission;
  }
}

export default CostHelpTypeForm;
